import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import './index.scss'

const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  icon = 'zmdi-info',
  children,
  size = 'large', // 'small', 'medium', 'large', 'xlarge'
  className = ''
}) => {
  // Body scroll lock
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }

    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [isOpen])

  // ESC tuşu ile kapatma
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className={`modal-container modal-${size} ${className}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="modal-title">
            <i className={`zmdi ${icon}`}></i>
            <div>
              <h3>{title}</h3>
              {subtitle && <span className="modal-subtitle">{subtitle}</span>}
            </div>
          </div>
          <button className="modal-close" onClick={onClose}>
            <i className="zmdi zmdi-close"></i>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default Modal

